'use client';

import { Header } from '@/components';
import Footer from '@/components/footer/Footer';
import { useThemeMode } from '@/context';

import {
  FlexItem,
  FlexLayout,
  Typography,
  Image,
  Container,
  Button,
  Icon,
} from '@wci-tech/core-ui';

import { useTranslations } from 'next-intl';
import { useStyles } from './comingsoon.styles';
import { BsArrowUpRight } from 'react-icons/bs';

const ComingSoon = () => {
  const { isDark } = useThemeMode();
  const styles = useStyles(isDark);
  const t = useTranslations('ComingSoon');

  return (
    <>
      <Header showNavbar={false} disableScrollEffect />
      <main>
        <Container customStyles={styles.container}>
          <FlexLayout
            alignItems={'center'}
            justifyContent={'center'}
            direction={'column'}
            padding={{ default: 0 }}
            gap={{ default: 10, md: 18, lg: 24 }}
          >
            <FlexItem>
              <Image
                isImgDecorative={true}
                altText={t('imageAlt')}
                src="/images/comingSoonMobile.png"
                priority={true}
                fetchPriority="high"
                preload={true}
                loading="eager"
                objectFit="contain"
                width={{
                  default: 288,
                  md: 554,
                  lg: 624,
                }}
                height={{
                  default: 114,
                  md: 220,
                  lg: 248,
                }}
                sizes="(max-width: 767px) 288px, (max-width: 1023px) 554px, 624px"
                sources={[
                  {
                    srcSet: '/images/comingSoonDesktop.png',
                    media: '(min-width: 1024px)',
                    type: 'image/png',
                  },
                  {
                    srcSet: '/images/comingSoonTablet.png',
                    media: '(min-width: 768px)',
                    type: 'image/png',
                  },
                ]}
              />
            </FlexItem>
            <FlexItem>
              <Typography variant="h1" css={styles.comingSoonText}>
                {t('title')}
              </Typography>
            </FlexItem>
            <FlexItem>
              <Button
                appearance="outline"
                variant={isDark ? 'secondary' : 'primary'}
                effect="liquid-fill"
                icon={
                  <Icon
                    name={BsArrowUpRight}
                    size={{
                      default: '14px',
                      lg: '16px',
                    }}
                  />
                }
                iconPlacement="right"
                shape="pill"
                href="/"
                customStyles={{
                  icon: {
                    right: styles.btnIcon,
                  },
                }}
              >
                {t('button')}
              </Button>
            </FlexItem>
          </FlexLayout>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default ComingSoon;
